var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurgerMenuIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.333 7a1.333 1.333 0 100 2.667H21A1.333 1.333 0 1021 7H2.333zM2.333 15a1.333 1.333 0 000 2.667H21A1.333 1.333 0 0021 15H2.333z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuMzMzMzMgN0MxLjU5Njk1IDcgMSA3LjU5Njk1IDEgOC4zMzMzM0MxIDkuMDY5NzEgMS41OTY5NSA5LjY2NjY3IDIuMzMzMzMgOS42NjY2N0gyMUMyMS43MzY0IDkuNjY2NjcgMjIuMzMzMyA5LjA2OTcxIDIyLjMzMzMgOC4zMzMzM0MyMi4zMzMzIDcuNTk2OTUgMjEuNzM2NCA3IDIxIDdIMi4zMzMzM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBkPSJNMi4zMzMzMyAxNUMxLjU5Njk1IDE1IDEgMTUuNTk3IDEgMTYuMzMzM0MxIDE3LjA2OTcgMS41OTY5NSAxNy42NjY3IDIuMzMzMzMgMTcuNjY2N0gyMUMyMS43MzY0IDE3LjY2NjcgMjIuMzMzMyAxNy4wNjk3IDIyLjMzMzMgMTYuMzMzM0MyMi4zMzMzIDE1LjU5NyAyMS43MzY0IDE1IDIxIDE1SDIuMzMzMzNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };